(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.embed'

  angular
    .module(MODULE_NAME, [
      require('../sdk'),
      require('../sdk-config'),
      require('./embed')
    ])
    .config(embedConfig)

  embedConfig.$inject = ['$stateProvider', '$locationProvider', '$injector']
  function embedConfig ($stateProvider, $locationProvider, $injector) {
    /*
     * The below code is to remove the `#!` from URLs when this component is
     * embedded in non-Thismoment pages. However, because this component can be
     * placed on Glow pages, we need to make sure that this does not override
     * Glow router configurations.
     */
    if (!$injector.has('GlowConfig')) {
      $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
      })

      $stateProvider
        .state('embed', {
          url: window.location.pathname
        })
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/embed/index.js